import { render, staticRenderFns } from "./gradeClass.vue?vue&type=template&id=20ff70b4&scoped=true"
import script from "./gradeClass.vue?vue&type=script&lang=js"
export * from "./gradeClass.vue?vue&type=script&lang=js"
import style0 from "./gradeClass.vue?vue&type=style&index=0&id=20ff70b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff70b4",
  null
  
)

export default component.exports